import reduce from 'lodash/reduce'

export function aggregateTotals(basket) {
  // console.log('aggregateTotals basket=', basket)
  // Calc the totals of the basket
  if (basket.items) {
    const totals = reduce(
      basket.items,
      (result, item) => ({
        numOfItems: parseInt(result.numOfItems) + parseInt(item.offer.qty),
        save: result.save + Number(item.offer.save).toFixed(2) * item.offer.qty,
        total: result.total + Number(item.offer.price).toFixed(2) * item.offer.qty,
        // discount: (result.discount && { amount: result.discount.amount, description: result.discount.description }) || {},
        subTotal: result.subTotal + Number(item.offer.price).toFixed(2) * item.offer.qty,
        grandTotal: result.grandTotal + Number(item.offer.price).toFixed(2) * item.offer.qty,
        creditCard: {
          numOfItems: item.offer.paymentType === 'CC' ? parseInt(result.creditCard.numOfItems) + parseInt(item.offer.qty) : result.creditCard.numOfItems,
          save: item.offer.paymentType === 'CC' ? result.creditCard.save + Number(item.offer.save).toFixed(2) * item.offer.qty : result.creditCard.save,
          total: item.offer.paymentType === 'CC' ? result.creditCard.total + Number(item.offer.price).toFixed(2) * item.offer.qty : result.creditCard.total,
          // discount: 0, // TODO create the discount
          subTotal: item.offer.paymentType === 'CC' ? result.creditCard.subTotal + Number(item.offer.price).toFixed(2) * item.offer.qty : result.creditCard.subTotal,
          grandTotal: item.offer.paymentType === 'CC' ? result.creditCard.grandTotal + Number(item.offer.price).toFixed(2) * item.offer.qty : result.creditCard.grandTotal
        },
        directDebit: {
          numOfItems: item.offer.paymentType === 'DD' ? parseInt(result.directDebit.numOfItems) + parseInt(item.offer.qty) : result.directDebit.numOfItems,
          save: item.offer.paymentType === 'DD' ? result.directDebit.save + Number(item.offer.save).toFixed(2) * item.offer.qty : result.directDebit.save,
          total: item.offer.paymentType === 'DD' ? result.directDebit.total + Number(item.offer.price).toFixed(2) * item.offer.qty : result.directDebit.total,
          // discount: 0, // TODO create the discount
          subTotal: item.offer.paymentType === 'DD' ? result.directDebit.subTotal + Number(item.offer.price).toFixed(2) * item.offer.qty : result.directDebit.subTotal,
          grandTotal: item.offer.paymentType === 'DD' ? result.directDebit.grandTotal + Number(item.offer.price).toFixed(2) * item.offer.qty : result.directDebit.grandTotal
        }
      }),
      {
        numOfItems: 0,
        save: 0,
        total: 0,
        discount: basket.discount || {},
        subTotal: 0,
        grandTotal: 0,
        creditCard: {
          numOfItems: 0,
          save: 0,
          total: 0,
          discount: 0,
          subTotal: 0,
          grandTotal: 0
        },
        directDebit: {
          numOfItems: 0,
          save: 0,
          total: 0,
          discount: 0,
          subTotal: 0,
          grandTotal: 0
        }
      }
    )

    totals.total -= basket.discount.amount || 0
    console.log('aggregateTotals totals=', totals)
    return totals
  }

  // Default empty basket with cartId if there are no items in the basket
  return {
    items: {},
    numOfItems: 0,
    save: 0,
    total: 0,
    discount: 0,
    subTotal: 0,
    grandTotal: 0,
    creditCard: {
      numOfItems: 0,
      save: 0,
      total: 0,
      discount: 0,
      subTotal: 0,
      grandTotal: 0
    },
    directDebit: {
      numOfItems: 0,
      save: 0,
      total: 0,
      discount: 0,
      subTotal: 0,
      grandTotal: 0
    }
  }
}

export function isMaxQty(item) {
  // Intermedia SINGLE_ISSUES max qty usually 2
  if (item.offer.type === 'SINGLE_ISSUES') {
    return item.offer.qty >= 2
  }

  // Default Max item passed in the ENV, 10 usually LIVE
  return item.offer.qty >= process.env.ITEM_MAX_QTY
}

export function formatCurrency(price) {
  return '£' + Number(price).toFixed(2)
}

// Map MongoDB Basket to the Lecagy one for the time being
export function mapAPIIBasketItemToLegacy(IBasketItem) {
  return {
    ...IBasketItem,
    productId: IBasketItem.sku,
    offer: {
      ...IBasketItem.offer,
      productId: IBasketItem.offer.sku,
      url: IBasketItem.url_path
    }
  }
}
export function shouldForceUpdate(updatedAt) {
  // Get the current time in UTC format
  const currentTime = new Date().getTime()

  // Parse the updatedAt string to a Date object
  const updatedAtTime = new Date(updatedAt).getTime()

  // Calculate the time difference in milliseconds
  const timeDifference = currentTime - updatedAtTime

  // Check if the time difference is greater than or equal to 10 minutes (600,000 milliseconds)
  const tenMinutesInMilliseconds = process.env.NODE_ENV === 'production' ? 10 * 60 * 1000 : 10 * 1000
  const forceUpdate = timeDifference >= tenMinutesInMilliseconds

  console.log(`shouldForceUpdate=${forceUpdate}`)
  return forceUpdate
}

export function RemoveOldBasketAndCart(context) {
  // Check if there is Vue3 Funnel Order already present
  // const basketId = context.$store.getters['basket/id']
  // const cartId = context.$store.getters['cart/CartId']
  // const lastOrderId = context.$store.getters['cart/LastOrderId']
  const orderCompleted = context.$store.getters['cart/OrderCompleted']
  // console.info(`RemoveOldBasketAndCart basketId=${basketId}`)
  // console.info(`RemoveOldBasketAndCart cartId=${cartId}`)
  // console.info(`RemoveOldBasketAndCart lastOrderId=${lastOrderId}`)
  console.info(`RemoveOldBasketAndCart orderCompleted=${orderCompleted}`)
  if (orderCompleted === true) {
    // Remove Vue3 localStorage
    if (!process.server && window?.localStorage) {
      window && window.localStorage.removeItem('Order')
      window && window.localStorage.removeItem('order')
      window && window.localStorage.removeItem('user')
      context.$store.commit('basket/id', undefined)
      context.$store.commit('basket/items', [])
      context.$store.commit('cart/CartId', undefined)
      context.$store.commit('cart/LastOrderId', undefined)
      context.$store.commit('cart/OrderCompleted', undefined)
      // window && window.sessionStorage.removeItem('basket')
      // window && window.localStorage.removeItem('cart')
      console.info(`RemoveOldBasketAndCart BASKET and CART Funnel related state's props REMOVED`)
    }
  } else {
    console.info(`RemoveOldBasketAndCart DO NOTHING`)
  }
}

export function AggregateBasketItemsWithTheSameSKU({ basket }) {
  if (!basket) {
    return {}
  }

  const uniqueItems = basket?.items.reduce((acc, currentItem) => {
    const existingItem = acc.find(item => item.offer.sku === currentItem.offer.sku)

    const isSpecial = ['GIFT', 'EGFT', 'PLUS'].includes(currentItem.shortsite_code)

    if (!existingItem || isSpecial) {
      const newItem = { ...currentItem, offer: { ...currentItem.offer } }
      if (isSpecial) {
        if (newItem.shortsite_code === 'EGFT') {
          newItem.image_path = newItem.custom_fields.design.image
          newItem.title = `E-Gift Card`
          newItem.offer.name = `£${newItem.offer.price} E-Gift Card`
        }
        if (newItem.shortsite_code === 'GIFT') {
          newItem.image_path = newItem.custom_fields.design.image
          newItem.title = `Gift Card`
          newItem.offer.name = `£${newItem.offer.price} Gift Card`
        }
        if (newItem.shortsite_code === 'PLUS') {
          newItem.offer.name = `${newItem.offer.num_of_issues} months for £${newItem.offer.price} Saving ${newItem.offer.save}%`
        }
      }
      // Clone the item to avoid mutating the original
      acc.push({ ...newItem })
    } else {
      // Ensure qty is initialized
      existingItem.offer.qty = (existingItem.offer.qty || 1) + (currentItem.offer.qty || 1)
    }

    return acc
  }, [])

  // console.log('AggregateBasketItemsWithTheSameSKU uniqueItems=', uniqueItems)
  const newBasket = { ...basket, items: uniqueItems }

  return newBasket
}

export const UniqueDiscountCode = () => {
  const dateString = Date.now()
    .toString(36)
    .toUpperCase()
  // const randomness = Math.random()
  //   .toString(36)
  //   .substring(2)
  //   .toUpperCase()
  // return `AB-${dateString}-${randomness}`
  return `AB-${dateString}`
}

export async function ResetBasketCheckbox({ payload, context }) {
  console.log('ResetBasketCheckbox #ITEMS=', payload?.items.length || 0)
  if (payload?.items && payload?.items.length === 0) {
    console.log('ResetBasketCheckbox')
    // Update the Voucher Campaing via the basket API
    const data = {
      publisher_opt_in: false,
      magazinecouk_opt_out: false,
      voucher_campaign: null
    }

    const url = `${context.$config.APIProxyURL}/basket/id/${payload.id}/update-funnel-info`
    console.info(`ResetBasketCheckbox data=`, data)
    console.info(`ResetBasketCheckbox url=${url}`)

    const config = {
      method: 'put',
      maxBodyLength: Infinity,
      url,
      headers: {
        'Cache-Control': 'max-age=0',
        'Content-Type': 'application/json'
      },
      data
    }

    await context.$axios
      .request(config)
      .then(response => {
        console.info('ResetBasketCheckbox UPDATE_BASKET payload=', response.data.payload)
        return response.data.payload
      })
      .catch(error => {
        console.error('ResetBasketCheckbox UPDATE_BASKET error=', error)
        return false
      })
  }
}

function readStorageModule(storage, key) {
  try {
    const raw = storage.getItem(key)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    const value = parsed && typeof parsed === 'object' && Object.prototype.hasOwnProperty.call(parsed, key) ? parsed[key] : parsed
    return value && typeof value === 'object' ? value : {}
  } catch (e) {
    return {}
  }
}

// When a page is restored from the browser back/forward cache (bfcache) the in-memory Vuex state is
// the one frozen when the user left the page, while sessionStorage holds the latest basket written by
// the pages visited afterwards. Re-sync only the basket module from storage, and only when it differs.
// Returns true when the store has been updated.
export function RehydrateBasketFromStorage(store) {
  if (process.server || typeof window === 'undefined') return false

  const basket = readStorageModule(window.sessionStorage, 'basket')
  const nextBasket = { ...store.state.basket, id: undefined, items: [], num_of_items: 0, numOfItems: 0, ...basket }

  if (JSON.stringify(nextBasket) === JSON.stringify(store.state.basket)) {
    console.info(`RehydrateBasketFromStorage basket UP TO DATE id=${store.state.basket?.id} num_of_items=${store.state.basket?.num_of_items}`)
    return false
  }

  console.info(
    `RehydrateBasketFromStorage basket CHANGED id=${store.state.basket?.id} -> ${nextBasket.id} num_of_items=${store.state.basket?.num_of_items} -> ${nextBasket.num_of_items}`
  )
  store.replaceState({ ...store.state, basket: nextBasket })
  return true
}
